export function formatProgressData({ data }) {
  data.forEach((d) => {
    d.Date = new Date(d.Date).valueOf();
    d['Reasonableness Only + NLD Updated'] = d['Through Reasonableness Only'] + d['NLD Updated'];
  });
}
